import { render, staticRenderFns } from "./CareAdd.vue?vue&type=template&id=7cd725c8&"
import script from "./CareAdd.vue?vue&type=script&lang=js&"
export * from "./CareAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
